<!--
component: ListResult
author: Ken Nakamura
description: 検索検索結果リスト
-->
<template>
  <section class="list">
    <v-container fluid>
      <v-row class="mb-1">
        <v-col class="pa-0">
          <h2 style="text-align: center; margin: 0.5em;">
            {{ contentsTitle }}
          </h2>
          <h3 v-show="$vuetify.breakpoint.name!='xs'" style="text-align: center; margin: 0.5em;">
            {{ contentsMessage }}
          </h3>
          <h4 v-show="$vuetify.breakpoint.name=='xs'" style="text-align: center; margin: 0.5em;">
            {{ contentsMessage }}
          </h4>
          <h4 v-show="$vuetify.breakpoint.name!='xs'" style="text-align: center; margin: 0.5em;">
            {{ subMessage }}
          </h4>
          <h5 v-show="$vuetify.breakpoint.name=='xs'" style="text-align: center; margin: 0.5em;">
            {{ subMessage }}
          </h5>
        </v-col>
        <v-col cols="2" style="position: relative;"
          v-show="topButtonVisible">
          <v-btn absolute top right x-large
            @click="browse" :disabled="!isSelected || loading" :loading="loading">
            {{ browseButtonTitle }}
          </v-btn>
        </v-col>
      </v-row>
      <ListAddress v-if="listContents==1 && mode==1" />
      <ListKyoaiAddress v-else-if="listContents==1 && mode==7" />
      <ListElvAddress v-else-if="mode==2" />
      <ListTeihoAddress v-else-if="mode==3" />
      <ListShiteiResult v-else-if="mode==4"/>
      <ListKaihatsuResult v-else-if="mode==5"/>
      <ListEstate v-else-if="listContents==2" />
      <ListSearchResult v-else-if="listContents==0"/>
      <ListKosakuAddress v-else-if="mode==8" />
      <v-row class="mt-1">
        <v-col class="py-0" style="position: relative;">
          <v-btn absolute top right x-large
            v-show="bottomButtonVisible"
            @click="browse"
            :disabled="!isSelected || loading || gaiyoDisabled"
            :loading="loading">
            {{ browseButtonTitle }}
          </v-btn>
        </v-col>
        <v-col class="py-0" style="position: relative;">
          <v-btn absolute top right x-large
            v-show="plotButtonVisible"
            @click="goPlot" :disabled="!isSelected || loading" :loading="loading">
            プロット図
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
		<Dialog error :open="errorDialog" :ok="()=>errorDialog=false"
      :title="errorTitle" :body="errorMessage"/>
  </section>
</template>

<script>
import ListAddress from '../components/ListAddress.vue'
import ListKyoaiAddress from '../components/ListKyoaiAddress.vue'
import ListElvAddress from '../components/ListElvAddress.vue'
import ListTeihoAddress from '../components/ListTeihoAddress.vue'
import ListEstate from '../components/ListEstate.vue'
import ListSearchResult from '../components/ListSearchResult.vue'
import ListShiteiResult from '../components/ListShiteiResult.vue'
import ListKaihatsuResult from '../components/ListKaihatsuResult.vue'
import ListKosakuAddress from '../components/ListKosakuAddress.vue'
import Dialog from '../components/Dialog.vue'
import { dbglog } from '../common/utils.js'
import { CallApi } from '../common/apiAccess'

export default {
  components: {
    ListAddress,
    ListKyoaiAddress,
    ListElvAddress,
    ListTeihoAddress,
    ListEstate,
    ListSearchResult,
    ListShiteiResult,
    ListKaihatsuResult,
    ListKosakuAddress,
    Dialog,
  },
  data: () => {
    return {
      loading: false,
      isSelected: false,
      errorDialog: false,
      errorTitle: '閲覧不可',
      errorMessage: '閲覧できません。',
    }
  },
  props: {
    listId: {
      type: Number,
      default: -1,
    },
    topButtonVisible: {
      type: Boolean,
      default: false,
    },
    bottomButtonVisible: {
      type: Boolean,
      default: true,
    },
  },
  mounted () {
    if (this.unauthorized) {
      this.message = 'ユーザー認証されていません。';
      this.$router.replace('/');
    }
    this.$store.commit('setCurrentPage', 6);
    dbglog(`listId: ${this.listId}`);
    if (this.listId >= 0) {
      this.listContents = this.listId;
    }
    this.setMessage();
    //this.isSelected = (this.gaiyoId != null && this.gaiyoId.length > 0);
    if (this.gaiyoId) {
      this.isSelected = true;
    }
    else {
      this.isSelected = false;
    }
    /* 暫定措置
    if (this.mode == 3) {
      this.isSelected = true;
    }
    */
  },
  computed: {
    token () {
      return this.$store.state.token;
    },
    unauthorized () {
      return this.token == undefined || this.token == null || this.token.length == 0;
    },
    authorized () {
      return !this.unauthorized;
    },
    message: {
      get() { return this.$store.state.message; },
      set(val) { this.$store.commit('setMessage', val) }
    },
    mode () {
      return this.$store.state.mode;
    },
    //List種別（0:番号検索結果 1:住所検索結果 2:物件検索結果）
    listContents: {
      get() { return this.$store.state.listId },
      set(id) { this.$store.commit('setListId', id) }
    },
    targetName () {
      switch (this.mode) {
      case 1:
        return '概要書';
      case 2:
        return '昇降機';
      case 3:
        return '定期報告';
      case 4:
        return '位置指定道路';
      case 5:
        return '開発登録簿';
      case 7:
        return '狭あい道路';
      case 8:
        return '工作物';
      default:
        return '情報';
      }
    },
    contentsTitle () {
      let count = 0;
      switch (this.listContents) {
      case 0:
        if (this.mode == 1) {
          return '受付番号検索結果';
        }
        else if (this.mode == 4) {
          return '位置指定番号検索結果';
        }
        else if (this.mode == 5) {
          return '許可番号検索結果';
        }
        else if(this.mode == 7) {
          return '地番検索結果';
        }
        else {
          return '番号検索結果';
        }
      case 1:
        if (this.kenkaku && this.kenkaku.length) {
          count = this.kenkaku.length;
        }
        // 狭あい道路の場合、文言変更
        if(this.mode == 7){
          return '地番検索結果' + ` (${count}件）`;
        }
        return '工作物検索結果' + ` (${count}件）`;
      case 2:
        return '物件検索結果';
      default:
        return '検索結果';
      }
    },
    contentsMessage () {
      switch (this.listContents) {
      case 0:
        return `以下の${this.targetName}が検索条件に一致します。`;
      case 1:
        return `以下の${this.targetName}が検索条件に一致します。`;
      case 2:
        return '同一物件の元確認、変更申請が存在します。';
      default:
        return '';
      }
    },
    subMessage () {
      return `閲覧したい${this.targetName}をタッチして選択し、[${this.browseButtonTitle}]ボタンを押してください。`;
    },
    kenkaku () {
      return this.$store.state.summaries;
    },
    gaiyoId () {
      return this.$store.state.gaiyoId;
    },
    ukeNo () {
      return this.$store.state.ukeNo;
    },
    gaiyo () {
      return this.$store.state.gaiyoData;
    },
    gaiyoDisabled () {
      return this.listContents==1 && this.mode==1 && this.gaiyo && !this.$store.state.gaiyoEnabled;
    },
    browseButtonTitle() {
      switch (this.mode) {
      case 1:
        return '概要書を閲覧';
      case 2:
        return '昇降機台帳を閲覧';
      case 3:
        return '定期報告概要書を閲覧';
      case 7:
        return '狭あい道路敷実測図を閲覧';
      case 8:
        return '工作物を閲覧';
      default:
        return '閲覧';
      }
    },
    plotButtonVisible() {
      return this.mode == 1 && this.listContents == 1;
    },
    wardCode() {
      return this.$store.state.wardCode;
    },
    wardName() {
      return this.$store.state.wardName;
    },
    townCode() {
      return this.$store.state.townCode;
    },
    townName() {
      return this.$store.state.townName;
    },
    oyaban() {
      return this.$store.state.oyaban;
    },
    edaban() {
      return this.$store.state.edaban;
    },
  },
  watch: {
    gaiyoId (newValue, oldValue) {
      /*
      dbglog(`ListResult.watch: gaiyoId(${newValue},${oldValue})`);
      if (newValue != null && (newValue > 0 || newValue.length > 0)) {
        this.isSelected = true;
        dbglog(`ListResult.watch: isSelected=${this.isSelected})`);
      }
      */
      if (newValue != oldValue) {
        if (newValue) {
          this.isSelected = true;
        }
        else {
          this.isSelected = false;
        }
      }
    },
  },
  methods: {
    /**
     * AppFooterに表示するメッセージを生成・登録する
     */
    setMessage () {
      const count = this.kenkaku.length;
      if (this.listContents == 1) {
        let addrText = `${this.wardName} ${this.townName}`;
        if (this.oyaban > 0) {
          addrText += ` ${this.oyaban}`;
          if (this.edaban > 0) {
            addrText += `-${this.edaban}`;
          }
        }
        this.message = `地名・地番検索結果：${addrText}  （${count}件）`;
      }
      else {
        this.message = `検索結果：${count}件`;
      }
    },
    /**
     * 現在選択されている概要書を表示する
     */
    browse () {
      dbglog(`ListResult.browse: listContents = ${this.listContents}`);
      if (this.listContents == 2) {
        //同一物件検索結果（ここには来ない？）
        this.$router.push({ name: 'loading', params: { action: 4 }});
      }
      else if (this.mode == 1) {
        //建築計画概要書
        if (this.gaiyo?.torisageKubun) {
          this.errorTitle = '閲覧不可';
          this.errorMessage = '取下げにつき閲覧できません。';
          this.errorDialog = true;
          return;
        }
        else if (this.gaiyo?.toriyameKubun) {
          this.errorTitle = '閲覧不可';
          this.errorMessage = '取止めにつき閲覧できません。';
          this.errorDialog = true;
          return;
        }
        /* 表示されるべき概要書が未処分扱いになる副作用が多すぎるので中止
        else if (this.gaiyo?.daichoId && this.gaiyo?.kojiId
          && this.gaiyo?.kknnNo !== undefined && this.gaiyo.kknnDay !== undefined ) {
          if ((this.gaiyo.kknnNo !== null && !this.gaiyo.kknnNo) ||
              (!this.gaiyo.kknnDay)) {
            this.errorTitle = '閲覧不可';
            this.errorMessage = '未処分につき閲覧できません。';
            this.errorDialog = true;
            return;
          }
        }
        */
        this.$router.push({ name: 'kousakuloading', params: { action: 2 }});
      }
      else if (this.mode == 2) {
        //昇降機、
        this.$router.push({ name: 'kousakuloading', params: { action: 4 }});
      }
      else if (this.mode == 3) {
        //定期報告概要書
        dbglog(`ListResult.browse(): teiho`)
        this.$router.push({ name: 'kousakuloading', params: { action: 4 }});
      }
      else if (this.mode == 5) {
        //開発・造成・土石の堆積（ここには来ない？）
        this.$router.push({ name: 'kousakuloading', params: { action: 4 }});
      }
      else {
        //その他（ここには来ない？）
        this.$router.push({ name: 'kousakuloading', params: { action: 4 }});
      }
    },
    goPlot() {
      if (this.ukeNo) {
        CallApi('XY', `?uke_no=${this.ukeNo}`, (data) => {
          if (data) {
            if (data.errorCode) {
              switch (data.errorCode) {
                case 400:
                  console.log(`error ${data.errorCode}: ${data.errorDesc}`);
                  break;
                case 404:
                  this.errorTitle = '';
                  this.errorMessage = '対応する確認プロットが見つかりません。';
                  this.errorDialog = true;
                  break;
                default:
                  console.log(`error ${data.errorCode}: ${data.message}`);
              }
            }
            else if (data.x) {
              this.$store.commit('setCenter', {x:data.x, y:data.y});
              this.$router.push({ name:'map', params:{targetPlot:data, zoom:19} });
            }
          }
        });
      }
    },
  }
}
</script>

<style lang="scss">
@import '../styles/common/common.css';
@import '../styles/table-styles.css';

.active {
  display: block;
}
.inactive {
  display: none;
}
</style>